// Canonical commercial account selectors (mirrors api/src/services/account-canonical.ts).

export function hasCanonicalNexusId(account) {
  return !!(account && String(account.nexusId || '').trim());
}

export function isSupersededAccount(account) {
  if (!account) return true;
  const status = String(account.status || '');
  const lifecycle = String(account.lifecycle || '');
  return status === 'SUPERSEDED' || lifecycle === 'SUPERSEDED';
}

export function isCanonicalCommercialAccount(account) {
  if (!account || isSupersededAccount(account)) return false;
  if (hasCanonicalNexusId(account)) return true;
  const by = String(account.createdBy || account.updatedBy || '').toLowerCase();
  const source = String(account.source || '').toLowerCase();
  if (
    by.includes('reseed') ||
    source === 'reseed' ||
    source === 'research' ||
    source === 'seed' ||
    source === 'apollo'
  ) {
    return false;
  }
  return true;
}

export function selectActiveCommercialAccounts(accounts = [], opts = {}) {
  let rows = (accounts || []).filter(isCanonicalCommercialAccount);
  if (opts.market) {
    rows = rows.filter((a) => (a.market || 'Dubai') === opts.market);
  }
  return rows;
}
